import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/Signup',
    component: () => import('../views/Signup.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/admin/Products.vue')
  },
  {
    path: '/Orders',
    name: 'Orders',
    props: true,
    component: () => import('../views/admin/Orders.vue')
  },
  {
    path: '/OrderLists',
    name: 'OrderLists',
    props: true,
    component: () => import('../views/admin/OrderLists.vue')
  },
  {
    path: '/members',
    name: 'Members',
    component: () => import('../views/admin/Members.vue')
  },
  {
    path: '/axios',
    component: () => import('../views/axios.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
